// ---------------------------------------------------------------------------
// useRecentSegments (AL-1850)
// ---------------------------------------------------------------------------
// The sidebar's RECENT SEGMENTS list.
//
// Only funnel personas are listed, and that is deliberate: they are the ones
// the app can open again (the Funnel loads them). Flat and lens personas have
// no page that reads them today, so listing them would produce rows that go
// nowhere.
// ---------------------------------------------------------------------------

import { useMemo } from 'react';
import { usePersonas, type Persona } from '@/hooks/usePersonas';
import { RECENT_SEGMENTS_LIMIT } from './constants';

export function sortByMostRecent(personas: readonly Persona[]): readonly Persona[] {
  return [...personas].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );
}

interface RecentSegments {
  readonly segments: readonly Persona[];
  readonly total: number;
  readonly isLoading: boolean;
}

export function useRecentSegments(limit: number = RECENT_SEGMENTS_LIMIT): RecentSegments {
  const { personas, isLoading } = usePersonas({ type: 'funnel' });

  return useMemo(
    () => ({
      segments: sortByMostRecent(personas).slice(0, limit),
      total: personas.length,
      isLoading,
    }),
    [personas, limit, isLoading]
  );
}
